var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselRightArrowButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 30C0.5 13.7076 13.7076 0.5 30 0.5C46.2924 0.5 59.5 13.7076 59.5 30C59.5 46.2924 46.2924 59.5 30 59.5C13.7076 59.5 0.5 46.2924 0.5 30Z",
    fill: "white",
    stroke: "#4987FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9468 21.1472C25.7008 21.3934 25.5626 21.7271 25.5626 22.0752C25.5626 22.4232 25.7008 22.757 25.9468 23.0031L32.4437 29.5L25.9468 35.9968C25.7078 36.2444 25.5755 36.5759 25.5785 36.9201C25.5815 37.2642 25.7195 37.5934 25.9628 37.8367C26.2062 38.0801 26.5354 38.2181 26.8795 38.2211C27.2236 38.2241 27.5552 38.0918 27.8027 37.8527L35.2275 30.4279C35.4736 30.1818 35.6118 29.848 35.6118 29.5C35.6118 29.1519 35.4736 28.8182 35.2275 28.572L27.8027 21.1472C27.5566 20.9012 27.2228 20.7629 26.8748 20.7629C26.5268 20.7629 26.193 20.9012 25.9468 21.1472Z",
    fill: "#4987FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselRightArrowButton);
export default __webpack_public_path__ + "static/media/Carousel_rightArrow_Button.f6c9a05eebc4a9b7778e6803ec42b38a.svg";
export { ForwardRef as ReactComponent };